import { useContext } from "react";
import Container from "../../../utils/Container";
import H2 from "../../../elements/titles/H2";
import ProductCard from "../components/ProductCard";
import productsContext from "../../../../dataManager/context/productsContext";
import LoaderCard from "../../../utils/loadersBox/LoaderCard";
import Button from "../../../elements/buttons/Button";

const Products = () => {
  //context variables
  const { products } = useContext(productsContext);

  const allLoadingCards = [1, 2, 3, 4, 5, 6, 7, 8].map((arg) => <LoaderCard />);

  const allproductsCards = products
    .slice(0, 8)
    .map((product) => <ProductCard key={product.getId} product={product} />);

  return (
    <Container classe="separedSection">
      <H2 classe="text-center">Liste des produits récemment ajoutés</H2>

      <div
        className={`${
          !allproductsCards.length &&
          "sm:grid-rows-4 md:grid-rows-3 lg:grid-rows-2"
        } mt-10 grid gap-8 sm:grid-cols-2  md:mt-16  md:grid-cols-3  lg:grid-cols-4 `}
      >
        {products.length > 0 ? allproductsCards : allLoadingCards}
      </div>
      <div className="mt-16 flex justify-center md:mt-20">
        <Button classe="inline-block" link="/produits">
          Consulter tous nos articles
        </Button>
      </div>
    </Container>
  );
};

export default Products;
